import clsx from 'clsx';
import React, { Fragment, useRef, PropsWithChildren } from 'react';
import { Popover } from '@headlessui/react';

import { ChevronDown as ArrowSVG, UserCircle as UserSVG } from '@td-client-frontend/icons';
import { UserInfo } from '../../../../types';

export interface ProfileMenuDropdownProps {
  userInfo: UserInfo;
}

export const ProfileMenuDropdown = ({ children, userInfo }: PropsWithChildren<ProfileMenuDropdownProps>) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const handlePopoverPanelClick = () => {
    buttonRef.current!.click();
  };

  return (
    <Fragment>
      <Popover className='flex flex-wrap justify-end w-48 h-12' data-testid='profile-menu-dropdown'>
        {({ open }) => (
          <Fragment>
            <Popover.Button
              ref={buttonRef}
              className='flex items-center h-12 px-3 py-2 space-x-2 text-black border-none rounded cursor-pointer hover:bg-gray-10 focus:outline-none'
            >
              <UserSVG className='w-4 h-4 fill-current' title='User Login Logo' />
              <div className='hidden sm:block'>
                <p className='text-left w-36 h-auto max-h-12 py-1 line-clamp-2'>
                  {`${userInfo?.first ?? ''} ${userInfo?.last ?? ''}`}
                </p>
              </div>
              <ArrowSVG
                aria-hidden='true'
                className={clsx(
                  'transition duration-200 transform',
                  open && 'rotate-180',
                  'block h-3 w-3 fill-current'
                )}
                title='Profile Menu Toggle Button'
              />
            </Popover.Button>
            <Popover.Panel
              className={clsx(
                open ? 'block' : 'hidden',
                'flex text-base z-40 my-2 list-none text-left rounded shadow-lg flex-col bg-white'
              )}
              onClick={handlePopoverPanelClick}
              style={{ minWidth: '12rem' }}
            >
              {children}
            </Popover.Panel>
          </Fragment>
        )}
      </Popover>
    </Fragment>
  );
};
